// const sum = require("./sum");
// import { sum2 } from "./sum2";
import style from "./css/index.scss";
// import Icon from './assets/img/proba.png';
// console.log("Hello World");
// console.log(sum.sum(2,2));
// console.log(sum2(2,2));

// let heading = document.querySelector("#demo"),
//     sumValue = sum.sum(10,5);

// heading.innerHTML = `2 + 15 = ${sumValue}`;

// let myIcon = new Image();
// myIcon.src = Icon;
// document.querySelector("div").appendChild(myIcon);